/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TournamentSwissStanding
 */
export interface TournamentSwissStanding {
    /**
     * 
     * @type {string}
     * @memberof TournamentSwissStanding
     */
    teamId?: string;
    /**
     * Team display name
     * @type {string}
     * @memberof TournamentSwissStanding
     */
    name?: string;
    /**
     * Wins plus byes (no draws in this format)
     * @type {number}
     * @memberof TournamentSwissStanding
     */
    matchPoints?: number;
    /**
     * 
     * @type {number}
     * @memberof TournamentSwissStanding
     */
    wins?: number;
    /**
     * 
     * @type {number}
     * @memberof TournamentSwissStanding
     */
    losses?: number;
    /**
     * 
     * @type {number}
     * @memberof TournamentSwissStanding
     */
    draws?: number;
    /**
     * Sum of opponents' match points
     * @type {number}
     * @memberof TournamentSwissStanding
     */
    buchholz?: number;
    /**
     * Buchholz with the lowest-scoring opponent dropped
     * @type {number}
     * @memberof TournamentSwissStanding
     */
    buchholzCut?: number;
    /**
     * Sum of beaten opponents' match points
     * @type {number}
     * @memberof TournamentSwissStanding
     */
    sonnebornBerger?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof TournamentSwissStanding
     */
    opponentIds?: Array<string>;
    /**
     * Head-to-head result ("win"/"loss") keyed by opponent team id
     * @type {{ [key: string]: string; }}
     * @memberof TournamentSwissStanding
     */
    matchResults?: { [key: string]: string; };
    /**
     * 
     * @type {number}
     * @memberof TournamentSwissStanding
     */
    gamesPlayed?: number;
}

/**
 * Check if a given object implements the TournamentSwissStanding interface.
 */
export function instanceOfTournamentSwissStanding(value: object): value is TournamentSwissStanding {
    return true;
}

export function TournamentSwissStandingFromJSON(json: any): TournamentSwissStanding {
    return TournamentSwissStandingFromJSONTyped(json, false);
}

export function TournamentSwissStandingFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentSwissStanding {
    if (json == null) {
        return json;
    }
    return {
        
        'teamId': json['teamId'] == null ? undefined : json['teamId'],
        'name': json['name'] == null ? undefined : json['name'],
        'matchPoints': json['matchPoints'] == null ? undefined : json['matchPoints'],
        'wins': json['wins'] == null ? undefined : json['wins'],
        'losses': json['losses'] == null ? undefined : json['losses'],
        'draws': json['draws'] == null ? undefined : json['draws'],
        'buchholz': json['buchholz'] == null ? undefined : json['buchholz'],
        'buchholzCut': json['buchholzCut'] == null ? undefined : json['buchholzCut'],
        'sonnebornBerger': json['sonnebornBerger'] == null ? undefined : json['sonnebornBerger'],
        'opponentIds': json['opponentIds'] == null ? undefined : json['opponentIds'],
        'matchResults': json['matchResults'] == null ? undefined : json['matchResults'],
        'gamesPlayed': json['gamesPlayed'] == null ? undefined : json['gamesPlayed'],
    };
}

export function TournamentSwissStandingToJSON(json: any): TournamentSwissStanding {
    return TournamentSwissStandingToJSONTyped(json, false);
}

export function TournamentSwissStandingToJSONTyped(value?: TournamentSwissStanding | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'teamId': value['teamId'],
        'name': value['name'],
        'matchPoints': value['matchPoints'],
        'wins': value['wins'],
        'losses': value['losses'],
        'draws': value['draws'],
        'buchholz': value['buchholz'],
        'buchholzCut': value['buchholzCut'],
        'sonnebornBerger': value['sonnebornBerger'],
        'opponentIds': value['opponentIds'],
        'matchResults': value['matchResults'],
        'gamesPlayed': value['gamesPlayed'],
    };
}

